import React from "react";
import type { ChannelLineupSectionProps } from "dds/organisms/channel-lineup/channel-lineup-section";
import type { LocalStationRules } from "lib/channel-lineup/local-stations";
import { APP_BASE_PATH } from "src/utils/app-base-path";
import { LineupZipControlLazy } from "../channel-lineup/lineup-zip-control-lazy.client";
import { splitZipCopy, type ZipCopyFields } from "../v3-zip-code/zip-copy";

export type LineupSlotProps = ChannelLineupSectionProps & ZipCopyFields & {
  /** Page-set by `attachLineupData`: the blok's package codes for the visitor's local rows. */
  localStationRules?: LocalStationRules;
};

/**
 * The Channel Lineup's slot props. `SLOT_FILLERS` runs this before the canvas renders the organism,
 * because CMS JSON cannot carry the node `zipSlot` takes. The ZIP copy and the local-station rules
 * come off here, so the organism never sees a `zip_*` field.
 */
export function fillLineupSlots({
  /* Dropped: off the wire this can only be JSON, never a node. */
  zipSlot: _authoredZipSlot,
  localStationRules,
  ...props
}: LineupSlotProps): ChannelLineupSectionProps {
  const { copy, rest } = splitZipCopy(props);
  return {
    ...rest,
    zipSlot: (
      <LineupZipControlLazy
        {...copy}
        autoOpenOnFirstVisit={false}
        localChannelsBasePath={APP_BASE_PATH}
        localStationRules={localStationRules}
      />
    )
  };
}
